export const meta: BlockMeta = {
  title: "Sponsors Item",
}

import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"
import { Link } from "eddev/routing"

export default defineBlock("content/sponsors-item", (props) => {
  const Wrap = props.link ? Link : "div"
  const wrapProps = props.link ? { href: props.link.url, target: props.link.target || "_blank" } : {}

  return (
    <Wrap {...wrapProps} className="col-span-1 relative">
      <div className="w-full h-0 pt-[100%] overflow-hidden" />
      <div className="absolute top-0 left-0 w-full h-full flex justify-center items-center">
        {props.image ? (
          <ResponsiveImage {...props.image} className="w-full h-full" objectFit="contain" objectPosition="center" />
        ) : (
          env.admin && (
            <div className="w-full h-0 pt-[100%] bg-grey1 border border-dashed border-black relative">
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">Sponsor</div>
            </div>
          )
        )}
      </div>
    </Wrap>
  )
})
